import React, { useEffect, useMemo, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import {
  verificationFormInputArr2,
  verificationFormSchema,
} from "./VerificationFormHelpers";
import { commonToast } from "../../Utils";
import {
  isValidEmail,
  LoadingButton,
  SpinnerBlock,
} from "../../Utils/CustomComponent";

// import slsLogo from "../../assets/images/loanlinq.png";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import urls from "../../Utils/urls";
import { loadingTypes, oracleConfig } from "../../Utils/constant";
import { useDispatch, useSelector } from "react-redux";
import { fetchUSStates } from "../../store/reducers/dashboardSlice/api";
import PopupWrapper from "../../components/PopupWrapper";
import {
  Building,
  CheckCircleFill,
  ChevronLeft,
  ClipboardCheck,
  CreditCard,
  ExclamationTriangle,
  ExclamationTriangleFill,
  FileEarmarkText,
  House,
  InfoCircle,
  Person,
  Search,
  Send,
  XCircleFill,
} from "react-bootstrap-icons";
import { Button } from "../../components/Button";
import {
  Card,
  Form,
  InputGroup,
  Button as ImportedButton,
  Alert,
} from "react-bootstrap";
import "./VerificationForm.css";
// import UseSignature from "../../components/FormBox/UseSignature";
import UseFormFileInput from "../../components/FormBox/UseFormFileInput";
import { VOMNavbar } from ".";
import ReviewInformation from "./ReviewInformation";
import PaymentStep from "./PaymentStep";
import PropertyAddressModal from "./PropertyAddressModal";
import axiosInstance from "../../axios";

const steps = [
  { title: "Requestor Details", sub: "Your information" },
  { title: "Property", sub: "Property address" },
  { title: "Applicant", sub: "Borrower info" },
  { title: "Review", sub: "Confirm details" },
  { title: "Payment", sub: "Choose payment" },
];

const headers = {
  "x-api-key": "12kXk3Xiou6Z50k0HSFZ5D8CScq2w6xJ",
};

const VOMStepperForm = () => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [showInvalidModal, setShowInvalidModal] = useState(false);
  const [invalidModalMessage, setInvalidModalMessage] = useState("");
  const [step, setStep] = useState(0);
  const [loanNumberLoading, setLoanNumberLoading] = useState(false);
  const [loanNumberStatus, setLoanNumberStatus] = useState(null);
  const [isValidAccount, setIsValidAccount] = useState(false);
  const [method, setMethod] = useState(null);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [stripeLoaded, setStripeLoaded] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showPropertySearch, setShowPropertySearch] = useState(false);
  const [noPropertyFound, setNoPropertyFound] = useState(false);
  const [validLoanNumber, setValidLoanNumber] = useState(null);
  const [limitReached, setLimitReached] = useState(false);
  const [checkingLimit, setCheckingLimit] = useState(true);
  const [invoiceID, setInvoiceID] = useState(null);
  const [paymentIntentId, setPaymentIntentId] = useState(null);
  const [vomNumber, setVomNumber] = useState(null);
  const [loanStatus, setLoanStatus] = useState(null);

  const states = useSelector((state) => state.dashboard.USstates.data);
  const status = useSelector((state) => state.dashboard.USstates.status);
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const { email } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const alertRef = useRef(null);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    setValue,
    trigger,
    setError,
    clearErrors,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(verificationFormSchema(isValidAccount)),
    defaultValues: {
      to_name: "Superior Loan Servicing",
      // to_address: "28348 Roadside Dr. 1st Floor\nAgoura Hills, CA 91301",
      to_street: "28348 Roadside Dr. 1st Floor",
      to_city: "Agoura Hills",
      to_state: "CA",
      to_zipcode: "91301",
      lender_date: new Date(),
      borrower_sign_available: false,
      lender_title: "Lender",
      masked_applicant_name: "",
      property_street: "",
    },
  });

  const display = watch("borrower_sign_available");
  const borrowerSignature = watch("borrower_signature");
  const knows_loan_account = watch("knows_loan_account");
  const borrower_email = watch("borrower_email");
  const remarks = watch("remarks");
  const property_street = watch("property_street");
  const property_city = watch("property_city");
  const property_state = watch("property_state");
  const property_zip = watch("property_zip");
  const propertyAddress = `${property_street} ${property_city}, ${property_state} ${property_zip}`;
  const dataForCheckingDuplicate = watch();

  const requestDate = new Date();

  useEffect(() => {
    const checkLimit = async () => {
      try {
        const res = await axios.get(urls.VOM.VOMCount(email), oracleConfig);
        // console.log(res?.data?.items?.[0]?.no_of_vom_created);

        if (res?.data?.items?.[0]?.no_of_vom_created >= 5) {
          setLimitReached(true);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setCheckingLimit(false);
      }
    };

    checkLimit();
  }, []);

  useEffect(() => {
    if (loanStatus === "Paid off") {
      setMethod("stripe");
    }
  }, [loanStatus]);

  useEffect(() => {
    if (status === loadingTypes.idle) {
      dispatch(fetchUSStates());
    }
  }, [dispatch, status]);

  // useEffect(() => {
  //   if (step === 1 && knows_loan_account === "N") {
  //     window.open(
  //       "https://support.loanlinq.com/ords/f?p=134",
  //       "_blank",
  //       "noopener,noreferrer"
  //     );
  //   }
  // }, [knows_loan_account, step]);

  if (!email || !isValidEmail(email)) {
    return <Navigate to="unauthorized" replace />;
  }

  const scrollToAlert = () => {
    alertRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  const next = async () => {
    // const fieldsToValidate
    // const isValid = await trigger();
    // if (!isValid) return;

    const valid = await trigger(
      verificationFormInputArr2?.[step]?.arr?.map((f) => f.field),
    );
    if (valid) setStep((s) => s + 1);
    else if (step === 1 && !valid) {
      scrollToAlert();
    }
  };

  const back = () => setStep((s) => Math.max(s - 1, 0));

  const onSubmit = async (data, comingFromStripe = false) => {
    setSubmitLoading(true);
    const id = toast.loading("Submitting Verification Form...");

    try {
      const trimmedData = Object.fromEntries(
        Object.entries(data).map(([k, v]) => [
          k,
          typeof v === "string" ? v.trim() : v,
        ]),
      );

      const payload = {
        ...trimmedData,
        to_name: "Superior Loan Servicing Inc.",
        to_address: "28348 Roadside Dr. 1st Floor - Agoura Hills, CA 91301",
        to_street: "28348 Roadside Dr. 1st Floor",
        to_city: "Agoura Hills",
        to_state: "CA",
        to_zipcode: "91301",
        email,
        borrower_signature: null,
        lender_date: moment(requestDate).toISOString(),
        borrower_sign_available: trimmedData?.borrower_sign_available
          ? "Y"
          : "N",
        payment_done: comingFromStripe ? "Y" : "N",
        invoice_id: paymentIntentId,
        vom_request_number: vomNumber,
      };

      const res = await axios.post(urls.VOM.submitVOM, payload, oracleConfig);
      if (res?.data?.status === "success") {
        if (trimmedData?.borrower_sign_available) {
          const sanitizedFileName = borrowerSignature.name.replace(/ /g, "_");

          const formData = new FormData();
          formData.append("document", borrowerSignature, sanitizedFileName);
          formData.append("request_id", res?.data?.request_id);

          const bucketResponse = await axiosInstance.post(
            urls.VOM.borrowerAuthBucketAPI,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            },
          );

          if (bucketResponse?.status == 200) {
            const authPayload = {
              request_id: bucketResponse?.data?.request_id,
              filename: bucketResponse?.data?.filename,
              file_mimetype: bucketResponse?.data?.file_mimetype,
              url: bucketResponse?.data?.url,
              created_by: email,
            };
            const finalApiRes = await axiosInstance.post(
              urls.VOM.uploadBorrowerAuth,
              authPayload,
              oracleConfig,
            );

            if (finalApiRes?.status == 200) {
              toast.update(id, {
                render: "Verification Form Submitted Successfully",
                type: "success",
                isLoading: false,
                ...commonToast,
              });

              navigate("/thankyou", {
                state: {
                  text: "Your VOM request has been successfully submitted.",
                  showBtn: false,
                },
              });
            }
          }
        } else {
          toast.update(id, {
            render: "Verification Form Submitted Successfully",
            type: "success",
            isLoading: false,
            ...commonToast,
          });

          navigate("/thankyou", {
            state: {
              text: "Your VOM request has been successfully submitted.",
              showBtn: false,
            },
          });
        }
      } else {
        const parsedRes = JSON?.parse(res?.data?.response);

        if (parsedRes?.message?.includes("Property address not found.")) {
          setShowInvalidModal(true);
          setInvalidModalMessage(
            "Invalid property address! Please enter a valid property address.",
          );
          toast.dismiss(id);

          return;
        } else if (parsedRes?.message?.includes("Loan Number not found.")) {
          setShowInvalidModal(true);
          setInvalidModalMessage(
            "Invalid loan account number! Please enter a valid loan account number.",
          );
          toast.dismiss(id);
          return;
        }
        toast.update(id, {
          render: "Verification Form Submitted Successfully",
          type: "success",
          isLoading: false,
          ...commonToast,
        });

        navigate("/thankyou", {
          state: {
            text: "Your VOM request has been successfully submitted.",
            showBtn: false,
          },
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.update(id, {
        render: "Submission Failed. Please try again.",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
      const payload = {
        paymentIntentId: paymentIntentId,
        reason: "VOM generation failed",
      };
      const res = await axios.post(urls.VOM.refundVOMFee, payload, { headers });
      const data = res?.data;
      if (res.status == 200) {
        navigate(`/vom/refund/${email}`, { state: { refundData: data } });
      }
    } finally {
      setSubmitLoading(false);
    }
  };

  const maskStreetSmart = (street) => {
    if (!street) return "";

    return street
      .split(" ")
      .map((word) => {
        const len = word.length;
        const half = Math.floor(len / 2);

        return word.substring(0, len - half) + "*".repeat(half);
      })
      .join(" ");
  };

  const handleFlag = () => {
    setSubmitFlag(true);
  };

  const validateLoanAccount = async () => {
    const accountNumber = watch("account_number");

    if (!accountNumber) {
      setError("account_number", {
        type: "manual",
        message: "Loan account number is required",
      });
      return;
    }

    try {
      setLoanNumberLoading(true);

      const res = await axios.get(
        urls.VOM.validateLoanNumber(accountNumber),
        oracleConfig,
      );

      if (res.data?.status === "success") {
        const data = res?.data?.primary_property;
        clearErrors("account_number");
        // ✅ mark as validated
        setIsValidAccount(true);
        setValidLoanNumber(res?.data?.account);
        setValue("applicant_name", res?.data?.["borrower name"]);
        setValue("borrower_mailing_address", res?.data?.["mailing_address"]);
        setValue(
          "masked_applicant_name",
          maskStreetSmart(res?.data?.["borrower name"]),
        );
        setValue("masked_property_street", maskStreetSmart(data?.street));
        setValue("property_street", data?.street);
        setValue("property_city", data?.city);
        setValue("property_state", data?.state);
        setValue("property_zip", data?.zipcode);

        setLoanStatus(res?.data?.loan_status);
        setLoanNumberStatus("success");
      } else {
        setLoanStatus(null);
        setValidLoanNumber(null);
        throw new Error();
      }
    } catch {
      setIsValidAccount(false);
      setValidLoanNumber(null);
      setLoanNumberStatus("error");
      setLoanStatus(null);

      setError("account_number", {
        type: "manual",
        message: "Invalid loan account number",
      });
      setValue("property_street", "");
      setValue("property_city", "");
      setValue("property_state", "");
      setValue("property_zip", "");
      setValue("applicant_name", "");
      setValue("borrower_mailing_address", "");
    } finally {
      setLoanNumberLoading(false);
    }
  };

  async function checkForDuplicate() {
    try {
      setSubmitLoading(true);
      const res = await axios.post(
        urls.VOM.checkDuplicateVOM,
        dataForCheckingDuplicate,
        oracleConfig,
      );
      // console.log(res, "res");
      if (res?.data?.Message === "Duplicate Record Exist.") {
        navigate(`/vom/duplicate/${email}`);
      } else {
        setVomNumber(res?.data?.["VOM Number"]);
        setStep((prev) => prev + 1);
      }
    } catch (error) {
      toast.error("Some error occured. Please try again");
      console.error(error);
    } finally {
      setSubmitLoading(false);
    }
  }

  if (checkingLimit) {
    return (
      <div style={{ marginTop: "130px" }}>
        <SpinnerBlock height="50vh" />
      </div>
    );
  }

  function handleCheckbox(e) {
    const checked = e.target.checked;
    setValue("borrower_sign_available", checked);
    if (!checked) {
      setValue("borrower_signature", undefined);
    }
  }

  return (
    <div className="bg-light min-vh-100" style={{ backgroundColor: "#F8FBFF" }}>
      {/* FIXED TOP NAVBAR */}
      <VOMNavbar />

      <div className="vf-header-wrapper" style={{ paddingTop: "6rem" }}>
        {limitReached && (
          <div className="d-flex justify-content-center align-items-center">
            <div className="alert alert-info text-center w-75 fw-bold">
              You have reached your daily limit of 5 VOM requests.
            </div>
          </div>
        )}
        {/* <div className="vf-header text-center" style={{ paddingTop: "7rem" }}> */}
        {/* <div className="vf-doc-pill">
          <FileEarmarkText size={16} />
          <span>Official Document</span>
        </div> */}

        <h1 className="vf-title">
          Request for Verification of Rent or Mortgage
        </h1>

        <p className="vf-subtitle">
          Complete the form below to submit your verification request.
          <br />
          All information is securely transmitted and protected.
        </p>
        {/* </div> */}
      </div>

      {/* Content */}
      <div className="vf-page">
        {/* ===== STEPPER ===== */}
        <div className="vf-stepper">
          {steps.map((s, i) => (
            <div key={i} className="vf-step-wrapper">
              <div
                className={`vf-step-circle ${
                  i < step ? "done" : i === step ? "active" : ""
                }`}
              >
                {i < step ? "✓" : i + 1}
              </div>
              <div className="vf-step-text">
                <div className="vf-step-title">{s.title}</div>
                <div className="vf-step-sub">{s.sub}</div>
              </div>
              {i < steps.length - 1 && <div className="vf-step-line" />}
            </div>
          ))}
        </div>

        {/* ===== CARD ===== */}
        <Card className="vf-card">
          {/* HEADER */}
          <div className="vf-card-header text-start">
            <div className="vf-icon">
              {step === 0 && <Building size={25} />}
              {step === 1 && <House size={25} />}
              {step === 2 && <Person size={25} />}
              {step === 3 && <ClipboardCheck size={25} />}
              {step === 4 && <CreditCard size={25} />}
            </div>
            <div>
              <div className="vf-header-title">{steps[step].title}</div>
              <div className="vf-header-sub">Step {step + 1} of 5</div>
            </div>
          </div>

          {/* BODY */}
          <div className="vf-card-body">
            {/* STEP 1 STATIC TO BOX */}
            {step === 0 && (
              <div className="vf-to-box text-start">
                <small>TO: NAME AND ADDRESS OF LENDER / CREDITOR</small>
                <p className="fw-bold mb-1">Superior Loan Servicing Inc.</p>
                <p className="mb-0 text-muted">
                  28348 Roadside Dr, 1st Floor
                  <br />
                  Agoura Hills, CA 91301
                </p>
              </div>
            )}

            <form
              style={{
                pointerEvents: limitReached ? "none" : "auto",
                opacity: limitReached ? 0.5 : 1,
              }}
            >
              <div
                style={{
                  maxHeight: "23rem",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                {step === 0 && (
                  <div className="row text-start">
                    <div className="vf-group col-6">
                      <label>From (Name of Requestor)</label>
                      <input
                        {...register("from_name")}
                        className={
                          errors.from_name ? "vf-input error" : "vf-input"
                        }
                        placeholder="Enter requestor name"
                      />
                      {errors.from_name && (
                        <small className="text-error">
                          {errors.from_name.message}
                        </small>
                      )}
                    </div>

                    <div className="vf-group col-6">
                      <label>From (Address of Requestor)</label>
                      <input
                        {...register("from_address")}
                        className={
                          errors.from_address ? "vf-input error" : "vf-input"
                        }
                        placeholder="Enter requestor address"
                      />
                      {errors.from_address && (
                        <small className="text-error">
                          {errors.from_address.message}
                        </small>
                      )}
                    </div>

                    <div className="vf-group col-6">
                      <SelectField
                        label={"Title"}
                        field={"lender_title"}
                        placeholder={"Select..."}
                        options={[
                          { label: "Lender", value: "Lender" },
                          { label: "Broker", value: "Broker" },
                          { label: "Other", value: "Other" },
                        ]}
                        watch={watch}
                        setValue={setValue}
                      />
                    </div>

                    <div className="vf-group col-6">
                      <label>Lender's Number</label>
                      <input
                        {...register("lender_number")}
                        className={
                          errors.lender_number ? "vf-input error" : "vf-input"
                        }
                        // value={watch("lender_number")}
                        // onChange={(e) =>
                        //   setValue(
                        //     "lender_number",
                        //     formatPhoneNumber(e.target.value)
                        //   )
                        // }
                        placeholder="XXXXXXX"
                      />
                      {errors.lender_number && (
                        <small className="text-error">
                          {errors.lender_number.message}
                        </small>
                      )}
                    </div>
                  </div>
                )}

                {step === 1 && (
                  <>
                    <div className="vf-radio-card">
                      <h5 className="vf-radio-title text-start">
                        Do you know the Loan Account Number?
                      </h5>

                      <div className="vf-radio-options">
                        <label className="vf-radio-option">
                          <input
                            type="radio"
                            value="Y"
                            {...register("knows_loan_account")}
                          />
                          <span className="vf-radio-custom" />
                          <span className="vf-radio-label">Yes</span>
                        </label>

                        <label className="vf-radio-option">
                          <input
                            type="radio"
                            value="N"
                            {...register("knows_loan_account")}
                            onClick={() => setShowPropertySearch(true)}
                          />
                          <span className="vf-radio-custom" />
                          <span className="vf-radio-label">No</span>
                        </label>
                      </div>
                    </div>

                    {knows_loan_account === "Y" ? (
                      <div className="row">
                        <div className="vf-group col-12 text-start">
                          <label className="">Loan Account Number</label>

                          <div className={`input-with-action ${status || ""}`}>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter loan account number"
                              {...register("account_number")}
                            />

                            <LoadingButton
                              type="button"
                              className="btn btn-primary btn-sm btn-modern-outline validate-btn"
                              title={
                                loanNumberLoading ? "Validating..." : "Validate"
                              }
                              disabled={loanNumberLoading}
                              loading={loanNumberLoading}
                              onClick={validateLoanAccount}
                            />

                            {loanNumberStatus === "success" &&
                              !loanNumberLoading && (
                                <CheckCircleFill className="status-icon success" />
                              )}
                            {loanNumberStatus === "error" &&
                              !loanNumberLoading && (
                                <XCircleFill className="status-icon error" />
                              )}
                          </div>
                          {errors.account_number && (
                            <small className="text-error">
                              {errors.account_number.message}
                            </small>
                          )}
                        </div>
                        {isValidAccount && (
                          <div className="row text-start">
                            <div className="vf-group col-12">
                              <label>Property Address - Street</label>

                              <input
                                // {...register("property_street")}
                                {...register("masked_property_street")}
                                className={
                                  errors.property_street
                                    ? "vf-input error"
                                    : "vf-input"
                                }
                                placeholder="123 Main Street"
                                disabled
                              />
                            </div>
                            <div className="vf-group col-4">
                              <label>City</label>
                              <input
                                {...register("property_city")}
                                className={
                                  errors.property_city
                                    ? "vf-input error"
                                    : "vf-input"
                                }
                                placeholder="Los Angeles"
                                disabled
                              />
                            </div>
                            <div className="vf-group col-4">
                              <SelectField
                                label={"State"}
                                field={"property_state"}
                                placeholder={"Select..."}
                                options={states}
                                watch={watch}
                                setValue={setValue}
                                disable={true}
                              />
                            </div>
                            <div className="vf-group col-4">
                              <label>Zip Code</label>
                              <input
                                {...register("property_zip")}
                                className={
                                  errors.property_zip
                                    ? "vf-input error"
                                    : "vf-input"
                                }
                                placeholder="90001"
                                disabled
                              />
                            </div>

                            {/* {errors?.["loan_property"]?.message?.length && (
                              <div className="vf-group col-12 text-center">
                                <p className="text-error">
                                  {errors?.["loan_property"]?.message + "!"}
                                </p>
                              </div>
                            )} */}
                          </div>
                        )}
                        {/* <div className="vf-group col-12 text-start">
                          <label>Additional Notes (Optional)</label>
                          <textarea
                            className="vf-textarea"
                            {...register("notes")}
                            placeholder="Enter any additional notes or comments..."
                          />
                        </div> */}
                        {/* {errors?.["loan_property"]?.message?.length && (
                          <div className="vf-group col-12">
                            <p className="text-error">
                              {errors?.["loan_property"]?.message + "!"}
                            </p>
                          </div>
                        )} */}
                      </div>
                    ) : (
                      knows_loan_account === "N" && (
                        <>
                          <button
                            className="w-100 btn btn-outline-primary btn-modern-outline px-5 py-4 d-flex justify-content-center align-items-center"
                            onClick={() => setShowPropertySearch(true)}
                            type="button"
                          >
                            <Search className="me-5" />
                            Search Property Address
                          </button>
                          {selectedProperty ? (
                            <PropertyCard
                              selectedProperty={selectedProperty}
                              setShowPropertySearch={setShowPropertySearch}
                              setValue={setValue}
                              setLoanStatus={setLoanStatus}
                            />
                          ) : null}
                          {noPropertyFound ? (
                            <ManualEntryCard
                              borrower_email={borrower_email}
                              remarks={remarks}
                              setShowPropertySearch={setShowPropertySearch}
                            />
                          ) : null}
                          {/* <div className="row text-start mt-5">
                            <div className="vf-group col-12 text-start">
                              <label>Additional Notes (Optional)</label>
                              <textarea
                                className="vf-textarea"
                                {...register("notes")}
                                placeholder="Enter any additional notes or comments..."
                              />
                            </div>
                          </div> */}
                          {/* {errors?.["loan_property"]?.message?.length && (
                            <Alert
                              variant="error"
                              className="d-flex align-items-center gap-3 justify-content-center fw-bold"
                              ref={alertRef}
                            >
                              <ExclamationTriangle />
                              {errors?.["loan_property"]?.message}
                            </Alert>
                          )}
                          <div className="vf-note mt-5 text-start text-muted">
                            <strong>Note:</strong> Please enter the complete
                            property address details below.
                          </div>
                          <div className="row text-start">
                            <div className="vf-group col-12">
                              <label>Property Address - Street</label>
                              <input
                                {...register("property_street")}
                                className={
                                  errors.property_street
                                    ? "vf-input error"
                                    : "vf-input"
                                }
                                placeholder="123 Main Street"
                              />
                            </div>
                            <div className="vf-group col-4">
                              <label>City</label>
                              <input
                                {...register("property_city")}
                                className={
                                  errors.property_city
                                    ? "vf-input error"
                                    : "vf-input"
                                }
                                placeholder="Los Angeles"
                              />
                            </div>
                            <div className="vf-group col-4">
                              <SelectField
                                label={"State"}
                                field={"property_state"}
                                placeholder={"Select..."}
                                options={states}
                                watch={watch}
                                setValue={setValue}
                              />
                            </div>
                            <div className="vf-group col-4">
                              <label>Zip Code</label>
                              <input
                                {...register("property_zip")}
                                className={
                                  errors.property_zip
                                    ? "vf-input error"
                                    : "vf-input"
                                }
                                placeholder="90001"
                              />
                            </div>
                            <div className="vf-group col-12">
                              <label>Account in the name of (Borrower)</label>
                              <input
                                {...register("account_name")}
                                className={
                                  errors.account_name
                                    ? "vf-input error"
                                    : "vf-input"
                                }
                                placeholder="John Doe"
                              />
                            </div>
                            <div className="vf-group col-12 text-start">
                              <label>Additional Notes (Optional)</label>
                              <textarea
                                className="vf-textarea"
                                {...register("notes")}
                                placeholder="Enter any additional notes or comments..."
                              />
                            </div>
                          </div> */}
                        </>
                      )
                    )}
                  </>
                )}

                {step === 2 && (
                  <div className="row text-start">
                    <div className="vf-group col-12">
                      <label>Name of Applicant (Borrower)</label>
                      <input
                        {...register("applicant_name")}
                        hidden
                        className={
                          errors.applicant_name ? "vf-input error" : "vf-input"
                        }
                        placeholder="Full legal name"
                        disabled
                      />
                      <input
                        {...register("masked_applicant_name")}
                        className={
                          errors.masked_applicant_name
                            ? "vf-input error"
                            : "vf-input"
                        }
                        placeholder="Full legal name"
                        disabled
                      />
                    </div>

                    <div className="vf-group col-12">
                      <label>Borrower's Mailing Address</label>
                      <input
                        {...register("borrower_mailing_address")}
                        className={
                          errors.borrower_mailing_address
                            ? "vf-input error"
                            : "vf-input"
                        }
                        placeholder="Enter the borrower's mailing address..."
                      />
                    </div>
                    {/* <div className="vf-group col-6">
                      <label>Signature of Applicant</label>
                      <UseSignature
                        title={"Click to sign"}
                        field={"applicant_signature"}
                        register={register}
                        setValue={setValue}
                        watch={watch}
                        error={errors.applicant_signature}
                      />
                    </div> */}
                    <div className="vf-radio-box text-muted col-12">
                      <input
                        type="checkbox"
                        {...register("borrower_sign_available")}
                        onChange={handleCheckbox}
                      />
                      <p>
                        Please upload the borrower’s authorization if available.
                        If the authorization is not provided, a notification
                        will be sent to the borrower requesting their signature
                        for the pending VOM request.
                      </p>
                    </div>
                    {display && (
                      <div className="vf-group col-12 mt-5">
                        <UseFormFileInput
                          title={"Borrower's Authorization"}
                          field={"borrower_signature"}
                          setValue={setValue}
                          error={errors?.borrower_signature?.message}
                          // isbase64={true}
                          accept={"application/pdf"}
                          dragAndDrop={true}
                          files={borrowerSignature}
                        />
                      </div>
                    )}
                  </div>
                )}

                {step === 2 && (
                  <div className="p-5 m-5 bg-warning bg-opacity-10 text-start">
                    <p className="mb-0 small">
                      <strong>Note:</strong>{" "}
                      <span className="text-muted">
                        The confidentiality of the information you have
                        furnished will be preserved except where disclosure of
                        this information is required by applicable law. The form
                        is to be transmitted directly to the lender and is not
                        to be transmitted through the applicant or any other
                        party.
                      </span>
                    </p>
                  </div>
                )}
                {step === 3 && (
                  <ReviewInformation
                    data={watch()}
                    onEditSection={(step) => setStep(step)}
                    isValidAccount={isValidAccount}
                  />
                )}
                {step === 4 && (
                  <PaymentStep
                    method={method}
                    setMethod={setMethod}
                    submitFlag={submitFlag}
                    onSuccess={onSubmit}
                    data={watch()}
                    setStripeLoaded={setStripeLoaded}
                    setSubmitLoading={setSubmitLoading}
                    email={email}
                    validLoanNumber={validLoanNumber}
                    propertyAddress={propertyAddress}
                    invoiceID={invoiceID}
                    setInvoiceID={setInvoiceID}
                    paymentIntentId={paymentIntentId}
                    setPaymentIntentId={setPaymentIntentId}
                    vomNumber={vomNumber}
                    loanStatus={loanStatus}
                  />
                )}
              </div>
              {/* FOOTER */}
              <div className="vf-actions">
                <button
                  type="button"
                  className="btn btn-secondary border"
                  onClick={back}
                  disabled={step === 0}
                  style={
                    step === 0 ? { cursor: "not-allowed", color: "gray" } : null
                  }
                >
                  <ChevronLeft /> Previous
                </button>

                {step < 3 ? (
                  <button
                    type="button"
                    className="vf-primary-btn"
                    onClick={next}
                    disabled={
                      (step === 1 && knows_loan_account == null) ||
                      (step === 1 &&
                        knows_loan_account === "Y" &&
                        !isValidAccount) ||
                      (step === 1 &&
                        knows_loan_account === "N" &&
                        !selectedProperty &&
                        !borrower_email?.length)
                    }
                    style={
                      (step === 1 && knows_loan_account == null) ||
                      (step === 1 &&
                        knows_loan_account === "Y" &&
                        !isValidAccount)
                        ? { cursor: "not-allowed" }
                        : null
                    }
                    title={
                      ((step === 1 && knows_loan_account == null) ||
                        (step === 1 &&
                          knows_loan_account === "Y" &&
                          !isValidAccount)) &&
                      "Please provide a complete property address or validate a loan account number."
                    }
                  >
                    Next Step →
                  </button>
                ) : step === 3 ? (
                  <LoadingButton
                    type="submit"
                    className="btn btn-primary btn-md py-4 btn-modern-outline"
                    title={"Next Step →"}
                    disabled={submitLoading}
                    loading={submitLoading}
                    onClick={checkForDuplicate}
                  />
                ) : (
                  <LoadingButton
                    type="submit"
                    className="btn btn-primary btn-md py-4 btn-modern-outline"
                    title={
                      method === "stripe" ? (
                        <span>
                          <Send className="me-4" />
                          Pay & Submit
                        </span>
                      ) : (
                        <span>
                          <Send className="me-4" />
                          Submit Request
                        </span>
                      )
                    }
                    disabled={
                      submitLoading ||
                      !method ||
                      (method === "stripe" && !stripeLoaded)
                    }
                    loading={submitLoading}
                    onClick={
                      method === "stripe"
                        ? handleSubmit(handleFlag)
                        : handleSubmit((formData) => onSubmit(formData, false))
                    }
                  />
                )}
              </div>
            </form>
          </div>
        </Card>
      </div>

      <InvalidModal
        show={showInvalidModal}
        setShow={setShowInvalidModal}
        message={invalidModalMessage}
      />
      <PropertyAddressModal
        show={showPropertySearch}
        setShow={setShowPropertySearch}
        states={states}
        selectedProperty={selectedProperty}
        setSelectedProperty={setSelectedProperty}
        noPropertyFound={noPropertyFound}
        setNoPropertyFound={setNoPropertyFound}
        setValueInMainForm={setValue}
        setValidLoanNumber={setValidLoanNumber}
      />
    </div>
  );
};

export default VOMStepperForm;

const formatPhoneNumber = (value) => {
  // Remove everything except digits
  const digits = value.replace(/\D/g, "").slice(0, 10);

  const len = digits.length;

  if (len < 4) return digits;
  if (len < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const SelectField = ({
  label,
  field,
  placeholder,
  options,
  watch,
  setValue,
  disable = false,
}) => {
  const value = options?.filter((data) => data.value === watch(field))[0];
  return (
    <>
      <label>{label}</label>
      <Select
        name={field}
        placeholder={placeholder}
        options={options}
        // {...register(field)}
        value={value || null}
        onChange={(selected) => {
          setValue(field, selected.value);
        }}
        styles={customStyles}
        menuPosition={"fixed"}
        isDisabled={disable}
      />
    </>
  );
};

const InvalidModal = ({ show, setShow, message }) => {
  return (
    <PopupWrapper
      title={
        <h2 className="p-4 font-weight-bold text-error">
          {" "}
          <ExclamationTriangleFill
            className="mt-2 me-2"
            color="#dc3545"
            size={25}
          />
        </h2>
      }
      extraClass="width-800"
      Component={
        <div>
          <p className="text-error">{message}</p>
          <div className="text-end">
            <Button text={"OK"} onClick={() => setShow(false)} />
          </div>
        </div>
      }
      toShow={show}
      closeEventHandler={() => setShow(false)}
      backdrop="static"
    />
  );
};

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "50px",
    minWidth: "250px",
    height: "30px",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    minHeight: "50px",
    height: "30px",
  }),
  container: (base) => ({
    ...base,
    width: "100%",
    height: "30px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    position: "absolute",
  }),
};

const PropertyCard = ({
  selectedProperty,
  setShowPropertySearch,
  setValue,
  setLoanStatus,
}) => {
  useEffect(() => {
    if (selectedProperty !== null) {
      setValue("property_street", selectedProperty?.STREET);
      setValue("property_city", selectedProperty?.CITY);
      setValue("property_state", selectedProperty?.STATE);
      setValue("property_zip", selectedProperty?.ZIPCODE);
      setValue("account_number", selectedProperty?.ACCOUNT);
      setValue("applicant_name", selectedProperty?.FULLNAME);
      setValue("account_name", selectedProperty?.FULLNAME);
      setValue("masked_applicant_name", selectedProperty?.MASKED_FULLNAME);
      setValue("borrower_mailing_address", selectedProperty?.BORROWER_MAILING_ADDRESS);

      setLoanStatus(selectedProperty?.LOAN_STATUS);
    }
  }, [selectedProperty?.STREET, setValue]);

  return (
    <div className="property-selected-card text-start mt-5">
      <div className="card-header">
        <InfoCircle size={20} />
        <strong>Property Selected</strong>
      </div>

      <div className="card-body">
        <p className="text-muted">
          <strong>Address:</strong> {selectedProperty.STREET}
        </p>
        <p className="text-muted">
          <strong>City:</strong> {selectedProperty.CITY},{" "}
          {selectedProperty.STATE} {selectedProperty.ZIPCODE}
        </p>
        <p className="text-muted">
          <strong>Borrower:</strong> {selectedProperty.MASKED_FULLNAME}
        </p>
        <p className="text-muted">
          <strong>Loan #:</strong> {selectedProperty.MASKED_ACCOUNT}
        </p>

        <button
          className="link-btn"
          type="button"
          onClick={() => setShowPropertySearch(true)}
        >
          Change Selection
        </button>
      </div>
    </div>
  );
};

const ManualEntryCard = ({
  setShowPropertySearch,
  borrower_email,
  remarks,
}) => {
  return (
    <div className="property-selected-card-yellow text-start mt-5">
      <div className="card-header">
        <InfoCircle size={20} />
        <strong>Property Not Found - Manual Entry</strong>
      </div>

      <div className="card-body">
        <p className="text-muted">
          <strong>Borrower Email:</strong> {borrower_email}
        </p>
        <p className="text-muted">
          <strong>Remarks:</strong> {remarks}
        </p>

        <button
          className="link-btn"
          type="button"
          onClick={() => setShowPropertySearch(true)}
        >
          Search Again
        </button>
      </div>
    </div>
  );
};
